import { styled } from '@linaria/react';

import ClientOnlySnippet from '@/components/CodeSnippet/ClientOnlySnippet';
import Paper from '@/components/Paper';

function SandpackCode({ code, children }) {
  const trimmedCode = code.trim();

  return (
    <Wrapper>
      <PseudoEditor>
        <Header>
          <RedButton />
          <YellowButton />
          <GreenButton />
        </Header>

        <CodeSnippet
          omitCopyButton
          lockedToColorMode="light"
          lang="jsx"
          code={trimmedCode}
        />
      </PseudoEditor>

      <ArrowSvg
        width="30"
        viewBox="0 0 82 288"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0456 1.56909C9.59849 -0.665245 5.80342 -0.492742 3.56909 1.95438C1.33475 4.40151 1.50726 8.19658 3.95438 10.4309L12.0456 1.56909ZM2.00319 282.196C2.11119 285.507 4.8836 288.105 8.19555 287.997L62.1669 286.237C65.4788 286.129 68.0761 283.356 67.9681 280.045C67.8601 276.733 65.0877 274.135 61.7758 274.243L13.8013 275.808L12.2369 227.833C12.1289 224.521 9.35647 221.924 6.04452 222.032C2.73257 222.14 0.135255 224.912 0.243253 228.224L2.00319 282.196ZM3.95438 10.4309C49.0728 51.6259 70.2329 95.3545 69.8752 139.827C69.5165 184.43 47.5073 231.053 3.62134 277.898L12.3787 286.102C57.4927 237.947 81.4835 188.57 81.8748 139.923C82.2671 91.1455 58.9272 44.3741 12.0456 1.56909L3.95438 10.4309Z"
          fill="var(--color-text)"
        />
      </ArrowSvg>

      <SandpackContent>{children}</SandpackContent>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin: 32px 0px 72px 0px;
`;

const Chunk = styled(Paper)`
  border-radius: 8px;
  background-color: white;
  /* trim corners */
  overflow: hidden;
  --shadow-color: 0deg 0% 0%;
  /* prettier-ignore */
  box-shadow:
    0px 1px 2px hsl(0deg 0% 0% / 0.05),
    0px 2px 4px hsl(0deg 0% 0% / 0.05),
    0px 4px 8px hsl(0deg 0% 0% / 0.05),
    0px 8px 16px hsl(0deg 0% 0% / 0.05),
    0px 16px 32px hsl(0deg 0% 0% / 0.05),
    0px 32px 64px hsl(0deg 0% 0% / 0.05);
`;

const PseudoEditor = styled(Chunk)`
  max-width: min(100%, 610px);
`;

const Header = styled.div`
  display: flex;
  gap: 8px;
  padding: 8px;
  background: hsl(228deg 10% 94%);
`;

const IosButton = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 1000px;
`;

const RedButton = styled(IosButton)`
  background: hsl(5deg 80% 65%);
`;
const YellowButton = styled(IosButton)`
  background: hsl(40deg 85% 65%);
`;
const GreenButton = styled(IosButton)`
  background: hsl(110deg 50% 55%);
`;

const ArrowSvg = styled.svg`
  display: block;
  transform: translateX(50%);
`;

const SandpackContent = styled(Chunk)`
  --scrollbar-width: unset;
  --scrollbar-color: #aaa;
  --scrollbar-background-color: white;
  width: 100%;
  padding: 16px;
`;

const CodeSnippet = styled(ClientOnlySnippet)`
  font-size: 0.875rem;
  padding: 0;
  /* allow horizontal scroll on smaller screens */
  max-width: 100%;
  /* Making this a container causes an issue where it's no longer sized by its contents, shrinking down to 0px wide */
  container-type: revert;

  pre {
    padding: 0px !important;
  }

  @media (max-width: 42rem) {
    pre {
      white-space: pre-wrap !important;
    }
  }
`;

export default SandpackCode;
